export default "__VITE_ASSET__k$EZas4W__"